import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import huayraHero from "@/assets/huayra-r-hero.jpg";
const Hero = () => {
  return <section className="relative h-screen min-h-[700px] flex items-end">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img src={huayraHero} alt="Pagani Huayra R supercar at Hyper Haus Los Angeles — PPF and ceramic coating specialists" className="w-full h-full object-cover object-center" />
        <div className="hero-overlay absolute inset-0" />
      </div>

      {/* Content */}
      <div className="relative container pb-4">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="max-w-3xl">
          <p className="text-primary text-sm uppercase tracking-[0.3em] mb-4">
        </p>
          <h1 className="section-heading text-5xl md:text-6xl lg:text-8xl mb-2">PROTECTION & CUSTOMIZATION<br />
            <span className="text-gradient"></span>
          </h1>
          <p className="text-lg md:text-xl text-muted-foreground max-w-xl mb-8">
            Over 30 years of hands-on experience serving superstars and hypercars. 
            Don't settle for corner-cutting applications—experience the difference.
          </p>
          
        </motion.div>

        {/* Stats */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="absolute bottom-20 md:bottom-32 right-4 md:right-8 hidden lg:flex flex-col gap-8">
          <div className="text-right">
            
            <p className="text-xs uppercase tracking-wider text-muted-foreground">
          </p>
          </div>
          <div className="text-right">
            <p className="text-4xl font-display">LA</p>
            <p className="text-xs uppercase tracking-wider text-muted-foreground">Hawthorne, CA</p>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.2
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2">
        <div className="w-[1px] h-16 bg-gradient-to-b from-foreground/50 to-transparent" />
      </motion.div>
    </section>;
};
export default Hero;